import { render, staticRenderFns } from "./RejectedAssignments.vue?vue&type=template&id=873e2ec4"
import script from "./RejectedAssignments.vue?vue&type=script&lang=js"
export * from "./RejectedAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports